import { SEARCH_KEYS } from '../../constants/query-params/search';

const searchStateToGqlPagination = (search: SearchState) => {
    // DO NOT CHANGE LIMIT TO 200 HERE, "SELECT ALL" IN MULTISELECT MODE STOPS WORKING AFTER THAT!!!!
    return `pagination: { limit: ${search.limit}, page: ${search[SEARCH_KEYS.PAGE]} }`;
};

export default searchStateToGqlPagination;
